import bitcore from "bitcore-lib";
import fetch from "node-fetch";

/**
 * Decode a raw BTC transaction
 */
export const DecodeBitcoinRawTx = (rawTxHex) => {
  try {
    const tx = new bitcore.Transaction(rawTxHex);
    return {
      txid: tx.id,
      version: tx.version,
      locktime: tx.nLockTime,
      inputs: tx.inputs.map((input) => ({
        txid: input.prevTxId.toString("hex"),
        index: input.outputIndex,
        sequence: input.sequenceNumber,
        script: input.script.toHex(),
      })),
      outputs: tx.outputs.map((output) => ({
        value: output.satoshis.toString(),
        script: output.script.toHex(),
      })),
    };
  } catch (err) {
    console.log("Failed to decode BTC raw transaction: ", err);
    throw new Error("Invalid Bitcoin raw transaction");
  }
};

/**
 * Broadcast a raw BTC transaction
 */
export const PublishBitcoinRawTx = async (rawTxHex, chainId = 0) => {
  const isTestnet = chainId === 3;
  const apiUrl = isTestnet
    ? "https://blockstream.info/testnet/api/tx"
    : "https://blockstream.info/api/tx";

  const res = await fetch(apiUrl, {
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    body: rawTxHex,
  });

  if (!res.ok) {
    const errorText = await res.text();
    console.log("Failed to broadcast BTC transaction: ", errorText);
    throw new Error("Failed to broadcast BTC transaction: " + errorText);
  }

  return await res.text(); // returns TXID
};

export const GetBitcoinBalance = async (address, chainId = 0) => {
  const isTestnet = chainId === 3;
  const apiUrl = isTestnet
    ? `https://blockstream.info/testnet/api/address/${address}`
    : `https://blockstream.info/api/address/${address}`;

  try {
    const response = await fetch(apiUrl);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return (
      data.chain_stats.funded_txo_sum - data.chain_stats.spent_txo_sum
    ).toString(); // balance in sats
  } catch (err) {
    console.log("Failed to get Bitcoin balance:", err);
    return "0"; // Return 0 balance on error
  }
};

/**
 * Convert satoshis to BTC
 */
export const FromSats = (sats) => {
  return (parseInt(sats) / 1e8).toFixed(8);
};
